<template>
  <div class="babybooksetting">
    <div>
      <editCubeBox title="周晬禮讚費用" :edit="edit" @edit="edit=$event"
      :headerStyle="{justifyContent: 'flex-start', gap: '20px'}"
      @save="save"
      @cancel="cancel"
      >
      <table>
        <thead>
          <tr>
            <th>品項</th>
            <th>貨編</th>
            <th>售價</th>
            <th>說明</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="({
            name,
            id,
            price,
            description
          }, i) in babyformula" :key="`b-${i}`">
            <td>{{name}}</td>
            <td>{{id}}</td>
            <td>
              <span v-if="!edit">$ {{price}}</span>
              <input v-else type="text" v-model.number="babyformula[i].price" class="babyPrice" :style="{width: '70px', height: '40px'}">
            </td>
            <td>
              <template v-if="name==='基本方案'">
              <div v-if="edit" :style="{marginBottom: '10px'}">
                # 成人數量限制<input type="text" v-model.number="babyAdultLimitation" class="limitation"> <span :style="{fontSize: '14px'}">%A% 將代入設定的成人數量</span>
              </div>
              <p v-if="!edit" v-html="description?description.replaceAll('\n', '<br>').replaceAll('%A%', babyAdultLimitation):''"></p>
              <textarea :style="{height: '100px'}" v-else v-model="babyformula[i].description"></textarea>
              </template>
              <template v-else>
                <p v-if="!edit" v-html="description?description.replaceAll('\n', '<br>'):''"></p>
                <textarea :style="{height: '100px'}" v-else v-model="babyformula[i].description"></textarea>
              </template>
            </td>
          </tr>
          <tr :style="{height: '50px'}">
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </table>
      </editCubeBox>
    </div>
  </div>
</template>

<script>
import editCubeBox from '../../components/editCubebox.vue'
import { postapi, getapi } from '../../store/fetch'
export default {
  components: {
    editCubeBox
  },
  data () {
    return {
      edit: false,
      babyAdultLimitation: null,
      babyformula: []
    }
  },
  name: '',
  mounted () {
    this.getdata()
  },
  methods: {
    cancel () {
      this.getdata()
      this.edit = false
    },
    async getdata () {
      const babyAdultLimitation = await getapi('selections/babyAdultLimitation')
      const babyformula = await getapi('selections/babyformula')
      if (babyAdultLimitation === false) {
        await postapi('selections/babyAdultLimitation', { key: 'value', data: 4 })
      } else {
        this.babyAdultLimitation = babyAdultLimitation
        if (babyformula === false) {
          await postapi('selections/babyformula', {
            key: 'optionsObj',
            data: [
              {
                id0: 'basic',
                name: '基本方案',
                id: '679900008',
                price: 3880,
                description: '%A%位成人(13歲以上)+1位寶寶\n(*最多填寫人數%A%人)'
              },
              {
                id0: 'children',
                name: '孩童觀禮',
                id: '679900009',
                price: 0,
                description: '˙7歲以下免費(憑健保卡)\n˙7~12歲直屬家長陪同免費\n(每位須至少一名家長陪同)'
              },
              {
                id0: 'twin',
                name: '雙胞胎加購',
                id: '679900020',
                price: 2000,
                description: '1位抓週寶寶'
              },
              {
                id0: 'adults',
                name: '成人觀禮加購',
                id: '679900011',
                price: 200,
                description: '1位成人'
              }
            ]
          })
        } else {
          this.babyformula = babyformula
        }
      }
    },
    async save () {
      const ret = await postapi('selections/babyAdultLimitation', { key: 'value', data: this.babyAdultLimitation })
      const ret2 = await postapi('selections/babyformula', { key: 'optionsObj', data: this.babyformula })
      if (ret) {
        this.babyAdultLimitation = ret
        this.babyformula = ret2
        this.edit = false
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.babyPrice {
  color: #E37878;
}
.limitation, .babyPrice {
  width: 60px;
  height: 30px;
  border: 1px solid var(--color-border);
  margin-inline: 10px;
  text-align: center;
  font-size: 18px;
  border-radius: 3px;
}
table {
  border: 1px solid var(--color-border);
  border-collapse: collapse;
  max-height: 100%;
  margin-top: 10px;
  width: -webkit-fill-available;
}
tbody {
  overflow-y: hidden;
}
thead {
  background-color: var(--color-checked);
  color: #FFFFFF;
  width: 100%;
  th {
    font-weight: 400;
  }
}
tr {
  min-height: 60px;
  &:not(:last-child) {
    border-bottom: 1px solid var(--color-border);
  }
  &>td, &>th {
    padding-inline: 17px;
    box-sizing: border-box;

    letter-spacing: 0.1em;
    font-size: 20px;
    padding-block: 10px;
    &:not(:last-child) {
      border-right: 1px solid var(--color-border);
    }
  }
  &>td {
    color: var(--color-letter);
    min-height: 60px;
  }
  &>:nth-child(1) {
    width: 270px;
    text-align: start;
  }
  &>:nth-child(2) {
    width: 160px;
  }
  &>:nth-child(3) {
    width: 125px;
    font-weight: 500;
    text-align: center;
  }
  &>td:nth-child(3) {
    color: #E37878;
  }
  &>:nth-child(4) {
    width: inherit;
    text-align: start;
  }
}
.editCube {
  &>div:nth-child(1) {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    &>button {
      margin-left: auto;
      width: 35px;
      height: 35px;
      background-color: var(--color-checked);
      background-image: url(/pen.svg);
      background-position: center;
      background-repeat: no-repeat;
      border: none;
      border-radius: 50%;
      background-size: 19px;
    }
  }
}
.imagebox2 {
  max-width: 461px;
  max-height: 346px;
  resize: both;
}
.resttitle {
  text-align: start;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 25px;
  line-height: 29px;
  letter-spacing: 0.1em;
  color: var(--color-checked);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 9px;
  textarea, p {
    padding: 16px 20px;
    border: 1px solid var(--color-border);
    height: 469px;
    text-align: start;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 150%;
    letter-spacing: 0.1em;
    color: var(--color-letter);
    width: -webkit-fill-available;
    min-width: 1000px;
    overflow: auto;
  }
  &>div:nth-child(1) {
    width: 461px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    &>button {
      margin-left: auto;
      width: 35px;
      height: 35px;
      background-color: var(--color-checked);
      background-image: url(/pen.svg);
      background-position: center;
      background-repeat: no-repeat;
      border: none;
      border-radius: 50%;
      background-size: 19px;
    }
  }
}
.btns{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 28px;
  width: 100%;
  button {
    &:disabled {
      filter: contrast(.5);
    }
    border: none;
    width: 100px;
    height: 35px;
    border-radius: 20px;
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    &.confirm {
      background: #E37878;
    }
    &.cancel {
      background: #B8B8B8;
    }
  }
}
.editBtn {
  margin-left: auto;
}
label#uploadimage {
  width: 461px;
  height: 346px;
}
.imagebox {
  width: 461px;
  height: 346px;
  background-color: #DADADA;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  // &::before {
  //   content: '';
  //   width: 576px;
  //   height: 1px;
  //   position: absolute;
  //   background-color: #999;
  //   transform: rotate(37deg);
  // }
  // &::after {
  //   content: '';
  //   width: 576px;
  //   height: 1px;
  //   position: absolute;
  //   background-color: #999;
  //   transform: rotate(-37deg);
  // }
}
.uploadimage {
  margin-right: auto;
  width: 461px;
  height: 346px;
  background-image: url(/upload.svg);
  background-size: contain;
  display: inline-flex;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-position: left;
  position: relative;
  &::before {
    position: absolute;
    content: '匯入圖片';
    display: inline-flex;
    width: 100px;
    height: 35px;
    background-color: var(--color-checked);
    align-items: center;
    justify-content: center;
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    border-radius: 20px;
    left: 230px;
    top: 204px;
    transform: translateX(-50%);
  }
}
.babybooksetting {
  width: 100%;
  height: calc(100vh - 90px);
  display: grid;
  grid-template-columns: 1fr 620px;
  &>div:nth-child(1) {
    padding: 28px 43px;
    overflow-y: auto;
    height: calc(100vh - 90px);
    box-sizing: border-box;
  }
  &>div:nth-child(2) {
    padding: 28px 43px;
    box-sizing: border-box;
    height: calc(100vh - 90px);
    border-left: 1px solid var(--color-border);
    overflow-y: auto;
  }
}

</style>
